import React, { useState } from 'react';
import { Box, Typography, Button, Paper, FormControl, Checkbox, MenuItem, Grid, Card, CardContent,Autocomplete, TextField, Tooltip} from '@mui/material';
import {Row, Col, message} from 'antd';
import axios from 'axios';
// import Highcharts from 'highcharts';
// import HighchartsReact from 'highcharts-react-official';
import { useEffect } from 'react';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

HighchartsMore(Highcharts);
// PackedBubble(Highcharts);
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


export const PeerGroupAnalysis = (props) => {

  const [loader, setloader] = useState(false)
  const [granularity, setGranularity] = useState(null);
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [AggregationMethod, setAggregationMethod] = useState({'label':'Sum',value:'sum'});
  const [DistributionData, setDistributionData] = useState(null)
  const [multiSelectOption, setMultiSelectOption] = React.useState([]);
  const [valueMltSelected, setValueMltSelected] = React.useState([]);
  const [SelectedTickerIds, setSelectedTickerIds] = React.useState(null);

  
  const GeneratePackedBubbleChart = () =>{
        Highcharts.chart('container', {
        chart: {
            type: 'packedbubble',
            height: '80%',
            backgroundColor:'var(--appBackground)'
        },
        title: {
            text: '',
        },
        tooltip: {
                    useHTML: true,
                    pointFormat: `<b>{point.name}</b><br/><br /><b>Contribution: </b>{point.value}%<br /> <b>Total ${AggregationMethod?.label}:</b> {point.options.${selectedColumn?.value}}`,
                    formatter: function() {                      
                        // Check if this is a parent node (continent) by checking if it has children
                        if (this.point.name === undefined && this.point.series) {
                            // Get the parent value from series options
                            var parentValue = this.point.series.options.value;
                            var number_of_entities = this.point.series.options.number_of_unique_entities;
                            return `<b>${this.point.series.options.security_name}</b><br /><br /> <b>Total ${AggregationMethod?.label}:</b> ${parentValue}<br/> <b>Number of Entities:</b> ${number_of_entities}`
                        }
                        // For regular points (countries)
                        if (this.point.name && this.point.value) {
                            return `<b>${this.point.name}</b><br /><br /><b>Contribution:</b> ${this.point.value}%<br /><b>Total ${AggregationMethod?.label}:</b> ${this.point.options[selectedColumn?.value]}`
                        }
                        // Fallback for parent nodes
                        var parentValue = this.point.series.options.value;
                        var number_of_entities = this.point.series.options.number_of_unique_entities;
                          return `<b>${this.point.series.options.security_name}</b><br /><br /> <b>Total ${AggregationMethod?.label}:</b> ${parentValue} <br /> <b>Number of Entities:</b> ${number_of_entities}`
                    }
                },

        plotOptions: {
            packedbubble: {
                minSize: '20%',
                maxSize: '130%',
                zMin: 0,
                zMax: 1000,
                layoutAlgorithm: {
                    gravitationalConstant: 0.05,
                    splitSeries: true,
                    seriesInteraction: false,
                    dragBetweenSeries: true,
                    parentNodeLimit: true
                },
                dataLabels: {
                    enabled: true,
                    format: '{point.name}',
                    filter: {
                        property: 'y',
                        operator: '>',
                        value: 250
                    },
                    style: {
                        color: 'black',
                        textOutline: 'none',
                        fontWeight: 'normal'
                    }
                }
            }
        },
        series: DistributionData,
        legend: {
            enabled: true,
            itemStyle: { color: "#2a5b93" },
            itemHoverStyle: {
                color: '#2a5b93'
            },
            maxHeight: 55,
            navigation: {
                activeColor: '#CCC',
                animation: true,
                arrowSize: 10,
                inactiveColor: '#3E576F',
                style: {
                    //fontWeight: 'bold',
                    color: '#fff',
                    fontSize: '10px'
                }
            }
        },
        credits:{
          enabled:false
        }
    });
  }

  const GetPeerGroupAnalysis = () => {
    setDistributionData(null)
    setloader(true)
    axios({
      method:'POST',
      url:'/api/dataset_coverage_distribution',
      data:{
        client_id:props?.SelectedProvider?.value,
        dataset_id:props?.SelectedProviderDataset?.value,
        period:granularity?.value,
        agg_method:AggregationMethod?.value,
        column:selectedColumn?.value,
        tickers:SelectedTickerIds
      }
    }).then(res=>{
        setDistributionData(res.data?.map((item) => {
          return {
            ...item,
            security_name:valueMltSelected?.filter(x=>x.id === item?.security_id)[0].label || item?.security_id,
            name:valueMltSelected?.filter(x=>x.id === item?.security_id)[0].label || item?.security_id,
          }
        }))
        setloader(false)
    }).catch(err=>{
        console.log(err);
        message.error(err?.response?.data?.error,3)
        setloader(false)
    })
  }


  useEffect(()=>{
    if (DistributionData && DistributionData?.length){
      GeneratePackedBubbleChart()
    }

  },[DistributionData])

  useEffect(()=>{
    if (SelectedTickerIds && SelectedTickerIds.length && granularity?.value && AggregationMethod?.value && selectedColumn?.value){
      GetPeerGroupAnalysis()
    }
  },[granularity,AggregationMethod,selectedColumn,SelectedTickerIds])

  useEffect(() => {
      const options = [];
      props.tickerData?.map((x) => {
          options.push({
              label: `${x.name} (${x.value})`,
              value: `${x.name} (${x.value}) ${x.althub_security_id}`,
              id : x.althub_security_id,
              ticker:x.value,
              security_name:x.name,
          })
      })
      setMultiSelectOption(options);
      return () => {}
  }, [ props.tickerData])

  


  return (
    <Box sx={{ p: 0 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3, color:'var(--textPrimary)' }}>
        <Box>
          <Typography variant="h2" sx={{ mb: 0.5 }}>
            Peer Group Analysis
          </Typography>
          <Typography variant="body1">
            Entity distribution patterns and concentration metrics
          </Typography>
        </Box>
        {/* <Button variant="contained">
          Export Data
        </Button> */}
      </Box>

      {/* Filter Controls */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, padding:'10px 0px 0px 15px' }}>
        <Grid container spacing={3}>
              <Grid size={1}>
                <FormControl size="small" sx={{ minWidth: 300, maxWidth:300, margin:'10px 10px ' }}>
                  <Tooltip
                      // key={key}
                      title={"You can select only up to 5 options"}
                      placement="bottom"
                      arrow
                    >
                    <Autocomplete
                          multiple
                          disabled={loader}
                          className="data-select"
                          size='small'
                          disablePortal
                          id="disable-clearable"
                          limitTags={4}
                          disableCloseOnSelect
                          value={valueMltSelected}
                          options={multiSelectOption}
                          renderOption={(props, option, { selected }) => {
                            const { key, ...optionProps } = props;                           
                            return (
                                <li {...optionProps}>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={
                                      option.all
                                        ? !!(valueMltSelected.length === multiSelectOption.length)
                                        : selected
                                    }
                                  />
                                  {option.label}
                                </li>
                            );
                          }}

                          renderInput={(params) => <TextField 
                            {...params} label='Search for Company' 
                              sx={{
                                    // Label color when disabled
                                    "& .MuiInputLabel-root.Mui-disabled": {
                                      color: "#ff0000", // example: red label
                                    },
                                    // Border color when disabled
                                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "var(--textPrimary)", // example: deep sky blue border
                                    },
                                    // Input text color when disabled
                                    "& .MuiInputBase-input.Mui-disabled": {
                                      color: "#555555", // example: dark gray text
                                    },
                                    // Optional: background color when disabled
                                    "& .MuiInputBase-root.Mui-disabled": {
                                      backgroundColor: "transparent",
                                    },
                                  }}
                          />}
                          getOptionDisabled={(option) =>
                            valueMltSelected.length >= 5 && !valueMltSelected.includes(option)
                          }

                          onChange={(event, newValue) => {
                              if (newValue.find(option => option.all)){
                                  const updatedFeatures = valueMltSelected.length === multiSelectOption.length ? [] : multiSelectOption;
                                  setValueMltSelected(updatedFeatures) 
                              }else{                                 
                                  setValueMltSelected(newValue)
                                  setSelectedTickerIds(newValue?.map(item=>item?.id))
                              }
                        
                            }}
                      />
                    </Tooltip>
                </FormControl>
              </Grid>
              <Grid size={6}>
                <FormControl size="small" sx={{ minWidth: 300, margin:'10px 5px ' }}>
                  <Autocomplete
                        className="data-select"
                        size='small'
                        disabled={loader}
                        disablePortal
                        id="disable-clearable"
                        disableClearable
                        fullWidth
                        onChange={(e,v) => {setSelectedColumn(v)}}
                        value={selectedColumn?.label}
                        options={props?.DatasetNumericColumns}
                        // renderInput={(params) => <TextField {...params} label='Choose a Column' />}
                        renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Choose a Column"
                              sx={{
                                    // Label color when disabled
                                    "& .MuiInputLabel-root.Mui-disabled": {
                                      color: "#ff0000", // example: red label
                                    },
                                    // Border color when disabled
                                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "var(--textPrimary)", // example: deep sky blue border
                                    },
                                    // Input text color when disabled
                                    "& .MuiInputBase-input.Mui-disabled": {
                                      color: "#555555", // example: dark gray text
                                    },
                                    // Optional: background color when disabled
                                    "& .MuiInputBase-root.Mui-disabled": {
                                      backgroundColor: "transparent",
                                    },
                                  }}

                              />)}

                    />
                </FormControl>
              </Grid>
              <Grid size={6}>
                <FormControl size="small" sx={{ minWidth: 200, margin:'10px 5px ' }}>
                    <Autocomplete
                        className="data-select"
                        size='small'
                        disabled={loader}
                        disablePortal
                        id="disable-clearable"
                        disableClearable
                        fullWidth
                        value={granularity}
                        defaultValue={granularity}
                        onChange={(e,v)=>{setGranularity(v)}}
                        getOptionDisabled={(option) => {
                                // Disable options based on the frequency value
                                if (props?.SelectedProviderDataset?.frequency == 'Weekly' && (option?.value === '1d')) {
                                    return true;
                                    }
                                if (props?.SelectedProviderDataset?.frequency == 'Monthly' && (option?.value === '1d' || option?.value === '1w')) {
                                    return true;
                                }
                                if (props?.SelectedProviderDataset?.frequency == 'Quarterly' && (option?.value === '1d'|| option?.value === '1w'|| option?.value === '1m')) {
                                    return true;
                                }
                                if (props?.SelectedProviderDataset?.frequency == 'Biannually' && (option?.value === '1d'|| option?.value === '1w'|| option?.value === '1m' || option?.value === '3m')) {
                                    return true;
                                }
                                if (props?.SelectedProviderDataset?.frequency == 'Yearly' && (option?.value === '1d'|| option?.value === '1w'|| option?.value === '1m' || option?.value === '3m' || option?.value === '6m')) {
                                    return true;
                                }
                                // Add more conditions based on the frequency value as needed
                                return false;
                            }}
                        options={
                          [{'label':'Last One Day',value:'1d'},
                          {'label':'Last One Week',value:'1w'},
                          {'label':'Last One Month',value:'1m'},
                          {'label':'Last Three Months',value:'3m'},
                          {'label':'Last Six Months',value:'6m'},
                          {'label':'Last One Year',value:'1y'},
                          {'label':'On Entire Data',value:'all'},
                          ]
                        }
                        renderInput={(params) => <TextField 
                                {...params} label='Choose a Time Period' 
                                sx={{
                                    // Label color when disabled
                                    "& .MuiInputLabel-root.Mui-disabled": {
                                      color: "#ff0000", // example: red label
                                    },
                                    // Border color when disabled
                                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "var(--textPrimary)", // example: deep sky blue border
                                    },
                                    // Input text color when disabled
                                    "& .MuiInputBase-input.Mui-disabled": {
                                      color: "#555555", // example: dark gray text
                                    },
                                    // Optional: background color when disabled
                                    "& .MuiInputBase-root.Mui-disabled": {
                                      backgroundColor: "transparent",
                                    },
                                  }}
                              />}
                    />
                </FormControl> 
              </Grid>         
              {/* <Grid size={6}>
                <FormControl size="small" sx={{ width: 180 , margin:'10px 10px '}}>
                  <Autocomplete
                      className="data-select"
                      size='small'
                      disablePortal
                      disabled={loader}
                      id="disable-clearable"
                      disableClearable
                      fullWidth
                      value={AggregationMethod}
                      defaultValue={AggregationMethod}
                      onChange={(e,v)=>{setAggregationMethod(v)}}
                      options={
                        [{'label':'Count',value:'count'},
                        {'label':'Sum',value:'sum'}]
                      }
                      renderInput={(params) => <TextField {...params} label='Choose a Aggregation'
                                  sx={{
                                    // Label color when disabled
                                    "& .MuiInputLabel-root.Mui-disabled": {
                                      color: "#ff0000", // example: red label
                                    },
                                    // Border color when disabled
                                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "var(--textPrimary)", // example: deep sky blue border
                                    },
                                    // Input text color when disabled
                                    "& .MuiInputBase-input.Mui-disabled": {
                                      color: "#555555", // example: dark gray text
                                    },
                                    // Optional: background color when disabled
                                    "& .MuiInputBase-root.Mui-disabled": {
                                      backgroundColor: "transparent",
                                    },
                                  }}
                      
                      />}
                  />
                </FormControl>
              </Grid> */}
        </Grid>
      </Box>

      {/* Distribution Chart */}
        <Paper sx={{ p: 3 }}>
          {DistributionData?.length > 0 &&
              <>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="h2" sx={{ mb: 1 }}>
                    Peer Group Bubble Chart
                  </Typography>
                  <Typography variant="body1">
                    Bubble size represents distribution percentage.
                  </Typography>
                </Box>
                
                <Grid container spacing={4}>
                  <Grid item xs={12} lg={12}>
                    <div id='container'></div>
                  </Grid>
                </Grid>
              </>
          }
          {DistributionData?.length === 0 && granularity?.value&&AggregationMethod?.value&&selectedColumn?.value && SelectedTickerIds.length&&
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                <Typography variant="h4" color="textSecondary">
                  No data available for the selected filters.
                </Typography>
              </Box>
          }
          {
            loader && 
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
              <Typography variant="h4" color="textSecondary">
                Loading data...
              </Typography>
            </Box>
          }
          {
            (!loader && !DistributionData || !granularity || !AggregationMethod || !selectedColumn || !SelectedTickerIds?.length )&&
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
              <Typography variant="h4" color="textSecondary">
                Please select filters to view the distribution chart.
              </Typography>
            </Box>
          }

        </Paper>

      {

      }
    </Box>
  );
};

export default PeerGroupAnalysis;
